export default function Employees() {
  return (
    <section className="sales-layout__page">
      <h1>Mitarbeiter</h1>
      <p>Die Mitarbeiterverwaltung ist in Vorbereitung.</p>
    </section>
  );
}
